import M from 'materialize-css'
//import moment from 'moment'
const toastMessage = (message, callback) => {
  return M.toast({html:message, completeCallback:()=>{
    callback 
   ? callback()
   : ''
  }})
 }
 const initModal = (el,options) => {
  const instance = M.Modal.init(el,options)
  return instance
}
 export default {
   toastMessage, initModal, 
 }